import { XIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../context/AppContext";
// import { useDeviceSettingsContext } from "../../context/DeviceSettingsContext";
import { useNotifications } from "../../hooks/useNotifications";
import { TNotification } from "../../types/Notifications";
import { SidebarNotification } from "./SidebarNotification";

const NotificationSlider = () => {
  const { setNotificationSliderVisible } = useAppContext();
  // const { onOpenDeviceModal, onCloseDeviceModal } = useDeviceSettingsContext();
  const {
    data: unreadNotifications,
    updateNotification,
    markAllAsRead,
  } = useNotifications({ is_read: false, limit: 20, sort: "updated_at|desc" });

  // const { data: readNotifications } = useNotifications({
  //   is_read: true,
  //   limit: 20,
  //   sort: "created_at|desc",
  // });

  const onMarkAllAsRead = async () => {
    await markAllAsRead();
  };

  const navigate = useNavigate();
  const onViewNotification = async (notification: TNotification) => {
    await updateNotification(notification._id, true);
    setNotificationSliderVisible(false);
    navigate(`/devices/${notification.device.device_id}`);
  };
  return (
    <div className="bg-white shadow-2xl absolute right-0 h-full px-4 md:pl-8 pt-8 md:w-1/3 overflow-y-scroll pb-4 z-50">
      <div className="flex justify-between items-center mb-5">
        <h3 className="text-2xl font-semibold">Notifications</h3>
        <button
          onClick={() => setNotificationSliderVisible(false)}
          className="text-gray-500 hover:text-gray-700"
        >
          <XIcon />
        </button>
      </div>
      {unreadNotifications.length > 0 && (
            <div
              className="text-right pr-10 text-blue-700 cursor-pointer mt-4"
              onClick={onMarkAllAsRead}
            >
              Clear Notifications
            </div>
          )}
      {!unreadNotifications && (
        <div className="text-center">
          <span className="text-gray-700">Loading...</span>
        </div>
      )}
      {unreadNotifications && unreadNotifications.length === 0 && (
        <div className="text-center">
          <span className="text-gray-700">No unread notifications</span>
        </div>
      )}
      {unreadNotifications && unreadNotifications?.length > 0 && (
        <div className="mb-5">
          <div className="text-xl font-semibold text-blue-700 mb-4">
            <span>New</span>
          </div>
          <div className="flex">
            <div className="border-4 rounded border-blue-700 mr-5" />
            <div className="divide-y">
              {unreadNotifications?.map((notification, idx) => (
                <SidebarNotification
                  notification={notification}
                  onClick={() => onViewNotification(notification)}
                />
              ))}
            </div>
          </div>
          {unreadNotifications.length > 0 && (
            <div
              className="text-right pr-10 text-blue-700 cursor-pointer mt-4"
              onClick={onMarkAllAsRead}
            >
              Mark All As Read
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default NotificationSlider;
